import React, { useState, useRef, useEffect } from "react";
import {
  uploadFile,
  getCategorySubcategory,
  coachWardrob,
  getUserById,
  imageProxy,
  uploadAndRemoveBg,
} from "../../apis";
import { toast } from "react-toastify";
import { IoMdClose } from "react-icons/io";
import "./OutfitEditor.css";
// import { useGesture } from "@use-gesture/react";


function OutfitEditor(props) {
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [isAccess,setIsAccess]=useState(false)
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedsubCategory, setSelectedsubCategory] = useState("");
  const [userWardrobModel, setUserWardrobModel] = useState(false);
  const [myWardrobeItems, setMyWardrobeItems] = useState([]);
  const [userWardrobeItems, setUserWardrobeItems] = useState([]);
  const [wardrobUrl, setWardrobUrl] = useState([]);
    const [newWardrobItem, setNewWardrobItem] = useState([]);
    const [selectedWardrobeItems, setSelectedWardrobeItems] = useState([]);
    const [namePopUp, setNamePopUp] = useState(false);
    const [imageName, setImageName] = useState("");
    const [nameError, setNameError] = useState("");
  
  const [selectedWardrobeIds, setSelectedWardrobeIds] = useState([]);
  const initialImages =isAccess ?  (props.initialImages || []) : "";
  const [zoom, setZoom] = useState(1);
  const lastTouchDistance = useRef(null);

  const fileInputRef = useRef(null);
  useEffect(()=>{
    if(userWardrobeItems.length>0){
      props.setWardrobeData(userWardrobeItems)
    }
  },[userWardrobeItems])
  const userDetails = localStorage.getItem("userDetails");
      const user_id = JSON.parse(userDetails)._id;
      
      
      const roomId= `${user_id}_${props.userId}`
      
  const [combinedImageUrl, setCombinedImageUrl] = useState(null);
  const editorRef = useRef(null);
  const dragRef = useRef({
    id: null,
    startX: 0,
    startY: 0,
    offsetX: 0,
    offsetY: 0,
  });
  
  // Touch gesture refs
  const touchRef = useRef({
    touching: false,
    initialDistance: 0,
    initialAngle: 0,
    initialWidth: 0,
    initialHeight: 0,
    initialRotation: 0,
  });
const updateImage = (updates) => {
    if (!selectedImage) return;
    const updatedImages = images.map((img) =>
      img.id === selectedImage.id ? { ...img, ...updates } : img
    );
    setImages(updatedImages);
    setSelectedImage({ ...selectedImage, ...updates });
  };

  // 🌀 Gesture handler
//   const bind = useGesture(
//     {
//       onPinch: ({ offset: [d, a] }) => {
//         // d = pinch distance (scale), a = rotation angle
//         if (!selectedImage) return;

//         // Adjust size with pinch
//         const scale = 1 + (d - 1) * 0.5;
//         updateImage({
//           width: selectedImage.width * scale,
//           height: selectedImage.height * scale,
//         });

//         // Adjust rotation with gesture angle
//         updateImage({
//           rotation: (selectedImage.rotation + a / 10) % 360, // smoother rotation
//         });
//       },
//     },
//     {
//       // ensures smoother behavior on touchscreen
//       pinch: { scaleBounds: { min: 0.5, max: 3 }, rubberband: true },
//       target: window,
//     }
//   );
//   useGesture(
//   {
//     onPinch: ({ offset: [d, a] }) => {
//       if (!selectedImage) return;

//       const scale = 1 + (d - 1) * 0.5;
//       updateImage({
//         width: selectedImage.width * scale,
//         height: selectedImage.height * scale,
//         rotation: (selectedImage.rotation + a / 10) % 360,
//       });
//     },
//   },
//   {
//     target: editorRef, // 👈 attach gestures to this div
//     pinch: { scaleBounds: { min: 0.5, max: 3 }, rubberband: true },
//   }
// );
  const handleFileChange = async (e, id, type) => {
    let newImageUrl;
    if (type === "url") {
      // Convert S3 URL to blob URL to avoid CORS issues
      if (e.includes('s3.') || e.includes('amazonaws.com')) {
        newImageUrl = await convertToBlob(e);
      } else {
        newImageUrl = e;
      }
      setWardrobUrl((prev) => [...prev, { url: e, itemId: id }]);
    } else if (type === "file") {
      const file = e.target.files[0];
      if (!file) return;
      const formData = new FormData();
      formData.append("file", file);
      const bgRemoveUrl = await uploadAndRemoveBg( formData);
      if(bgRemoveUrl?.status===200){
        newImageUrl=bgRemoveUrl?.data?.url
        // newImageUrl = await convertToBlob(e);
      }else{
        setNewWardrobItem((item) => [...item, file]);
        newImageUrl = URL.createObjectURL(file);
      }
    }
  
    const img = new Image();
    img.onload = () => {
      const aspectRatio = img.width / img.height;
      const newImage = {
        id: Date.now().toString(),
        url: newImageUrl,
        originalUrl: type === "url" ? e : newImageUrl, // Keep original URL for reference
        x: 0,
        y: 0,
        width: 100,
        height: 100 / aspectRatio,
        rotation: 0,
        zIndex: images.length,
      };
      setImages((prevImages) => [...prevImages, newImage]);
    };
    
    img.onerror = (error) => {
      console.error("Failed to load image:", newImageUrl, error);
      toast.error("Failed to load image. Please try again.");
    };
    
    img.src = newImageUrl;
  };
  // const imageProxy = (encodedUrl) => {
  //   return axios.get(`admins/coach/proxy-image?url=${encodedUrl}`, {
  //     responseType: 'arraybuffer' // <-- important!
  //   });
  // };
  
  const convertToBlob = async (imageUrl) => {
    try {
      // Use your backend proxy or direct fetch
      const response = await imageProxy(encodeURIComponent(imageUrl));
      
      if (response.status!==200) {
        throw new Error('Failed to fetch image');
      }
      const mimeType = response.headers['content-type'] || 'image/jpeg';
      const blob = new Blob([response.data], { type: mimeType });
  
      const blobUrl = URL.createObjectURL(blob);
    return blobUrl;
    } catch (error) {
      console.error('Failed to convert to blob:', error);
      return imageUrl; // Fallback to original URL
    }
  };
  const handleMouseDown = (e, id) => {
    e.preventDefault();
    const img = images.find((img) => img.id === id);
    if (img) {
      const rect = e.currentTarget.getBoundingClientRect();
      dragRef.current = {
        id,
        startX: e.clientX,
        startY: e.clientY,
        offsetX: e.clientX - rect.left,
        offsetY: e.clientY - rect.top,
      };
      bringToFront(id);
      setSelectedImage(img);
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }
  };

const handleMouseMove = (e) => {
  if (dragRef.current.id && editorRef.current) {
    const editorRect = editorRef.current.getBoundingClientRect();
    const img = images.find((img) => img.id === dragRef.current.id);

    const scaledWidth = editorRect.width / zoom;
    const scaledHeight = editorRect.height / zoom;

    let newX = (e.clientX - editorRect.left - dragRef.current.offsetX) / zoom;
    let newY = (e.clientY - editorRect.top - dragRef.current.offsetY) / zoom;

    newX = Math.max(0, Math.min(newX, scaledWidth - img.width));
    newY = Math.max(0, Math.min(newY, scaledHeight - img.height));

    setImages((prevImages) =>
      prevImages.map((img) =>
        img.id === dragRef.current.id ? { ...img, x: newX, y: newY } : img
      )
    );
    setSelectedImage((prevSelected) => ({
      ...prevSelected,
      x: newX,
      y: newY,
    }));
  }
};


  const handleMouseUp = () => {
    dragRef.current = {
      id: null,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
    };
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };

  const resizeImage = (scale) => {
    if (!selectedImage) return;
    updateImage({
      width: selectedImage.width * scale,
      height: selectedImage.height * scale,
    });
  };

  const rotateImage = () => {
    if (!selectedImage) return;
    updateImage({ rotation: (selectedImage.rotation + 90) % 360 });
  };

  const deleteImage = () => {
    if (selectedImage) {
      setImages(images.filter((img) => img.id !== selectedImage.id));
      setSelectedImage(null);
    }
  };
   const getDistance = (touch1, touch2) => {
    const dx = touch2.clientX - touch1.clientX;
    const dy = touch2.clientY - touch1.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  };

  // Helper function to calculate angle between two touch points
  const getAngle = (touch1, touch2) => {
    const dx = touch2.clientX - touch1.clientX;
    const dy = touch2.clientY - touch1.clientY;
    return Math.atan2(dy, dx) * (180 / Math.PI);
  };
  const handleImageTouchStart = (e, imageId) => {
    e.stopPropagation();
    const img = images.find((img) => img.id === imageId);
    if (!img) return;

    if (e.touches.length === 1) {
      // Single touch - start dragging
      const touch = e.touches[0];
      const rect = e.currentTarget.getBoundingClientRect();
      dragRef.current = {
        id: imageId,
        startX: touch.clientX,
        startY: touch.clientY,
        offsetX: touch.clientX - rect.left,
        offsetY: touch.clientY - rect.top,
      };
      bringToFront(imageId);
      setSelectedImage(img);
    } else if (e.touches.length === 2) {
      // Two fingers - start pinch/rotate gesture
      e.preventDefault();
      const touch1 = e.touches[0];
      const touch2 = e.touches[1];
      
      touchRef.current = {
        touching: true,
        initialDistance: getDistance(touch1, touch2),
        initialAngle: getAngle(touch1, touch2),
        initialWidth: img.width,
        initialHeight: img.height,
        initialRotation: img.rotation,
      };
      
      setSelectedImage(img);
      bringToFront(imageId);
      
      // Stop dragging when two fingers touch
      dragRef.current.id = null;
    }
  };
  const handleImageTouchMove = (e) => {
    if (e.touches.length === 1 && dragRef.current.id) {
      // Single touch - dragging
      e.preventDefault();
       e.stopPropagation();
      const touch = e.touches[0];
      
      if (editorRef.current) {
        const editorRect = editorRef.current.getBoundingClientRect();
        const img = images.find((img) => img.id === dragRef.current.id);

        let newX = touch.clientX - editorRect.left - dragRef.current.offsetX;
        let newY = touch.clientY - editorRect.top - dragRef.current.offsetY;

        newX = Math.max(0, Math.min(newX, editorRect.width - img.width));
        newY = Math.max(0, Math.min(newY, editorRect.height - img.height));

        setImages((prevImages) =>
          prevImages.map((img) =>
            img.id === dragRef.current.id ? { ...img, x: newX, y: newY } : img
          )
        );
        setSelectedImage((prevSelected) => ({
          ...prevSelected,
          x: newX,
          y: newY,
        }));
      }
    } else if (e.touches.length === 2 && touchRef.current.touching && selectedImage) {
      // Two fingers - pinch to zoom and rotate
      e.preventDefault();
       e.stopPropagation();
      const touch1 = e.touches[0];
      const touch2 = e.touches[1];
      
      const currentDistance = getDistance(touch1, touch2);
      const currentAngle = getAngle(touch1, touch2);
      
      // Calculate scale factor
      const scaleFactor = currentDistance / touchRef.current.initialDistance;
      const newWidth = touchRef.current.initialWidth * scaleFactor;
      const newHeight = touchRef.current.initialHeight * scaleFactor;
      
      // Calculate rotation change
      const angleDiff = currentAngle - touchRef.current.initialAngle;
      const newRotation = (touchRef.current.initialRotation + angleDiff) % 360;
      
      updateImage({
        width: newWidth,
        height: newHeight,
        rotation: newRotation,
      });
    }
  };
const handleImageTouchEnd = (e) => {
    if (e.touches.length === 0) {
      // All fingers lifted
      touchRef.current.touching = false;
      dragRef.current.id = null;
    } else if (e.touches.length === 1) {
      // One finger remaining - restart drag
      touchRef.current.touching = false;
      if (selectedImage) {
        const touch = e.touches[0];
        const rect = e.currentTarget?.getBoundingClientRect();
        if (rect) {
          dragRef.current = {
            id: selectedImage.id,
            startX: touch.clientX,
            startY: touch.clientY,
            offsetX: touch.clientX - rect.left,
            offsetY: touch.clientY - rect.top,
          };
        }
      }
    }
  };
  // Modified saveImage function: after combining the images, create an outfit object and console it
  const saveImage = async () => {
  if (images.length === 0) {
    alert("No images to combine");
    return;
  }

  try {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // 🔥 scale for HD output
    const scale = 3;
    const editorRect = editorRef.current.getBoundingClientRect();
    canvas.width = editorRect.width * scale;
    canvas.height = editorRect.height * scale;
    ctx.scale(scale, scale);

    const sortedImages = [...images].sort((a, b) => a.zIndex - b.zIndex);

    const imagesWithBlobs = await Promise.all(
      sortedImages.map(async (img) => {
        if (img.url.startsWith("blob:") || img.url.startsWith("data:")) {
          return img;
        }

        const blobUrl = await convertToBlob(img.url);
        return { ...img, url: blobUrl };
      })
    );

    const loadedImages = await Promise.all(
      imagesWithBlobs.map((img) => {
        return new Promise((resolve) => {
          const image = new Image();
          image.onload = () => resolve(image);
          image.onerror = (e) => {
            console.error("Failed to load blob image:", img.url, e);
            resolve(null);
          };
          image.src = img.url;
        });
      })
    );

    loadedImages.forEach((img, index) => {
      if (!img) return;

      const imgData = imagesWithBlobs[index];

      ctx.save();
      ctx.translate(
        imgData.x + imgData.width / 2,
        imgData.y + imgData.height / 2
      );
      ctx.rotate((imgData.rotation * Math.PI) / 180);

      ctx.drawImage(
        img,
        -imgData.width / 2,
        -imgData.height / 2,
        imgData.width,
        imgData.height
      );

      ctx.restore();
    });

    // 🔥 CROP empty white space
    const croppedCanvas = cropCanvas(canvas);

    // Save the cropped version
    croppedCanvas.toBlob(
      async (blob) => {
        const file = new File([blob], "combined_image.png", {
          type: "image/png",
        });

        const formData = new FormData();
        formData.append("file", file);

        let newImageUrl = await uploadFile(formData);

        const userDetails = localStorage.getItem("userDetails");
        const user_id = JSON.parse(userDetails)._id;
        const roomId = `${user_id}_${props.userId}`;

        const payload = {
          receiverId: props.userId,
          roomId: roomId,
          media: [],
          adminOutfit: {
            url: newImageUrl.data.url,
            categoryId: selectedCategory,
            subCategoryId: selectedsubCategory,
            wardrobeItems: selectedWardrobeItems,
            name: imageName,
          },
          senderType: "admin",
          message: "Suggested outfit created by admin",
          senderId: user_id,
        };

        props.socket.emit("send_message", payload);

        setWardrobUrl([]);
        setSelectedCategory("");
        setSelectedsubCategory("");
        setSelectedWardrobeItems([]);
        setImageName("");
        setNamePopUp(false);
        props.setCreateOutfit(false);

        imagesWithBlobs.forEach((img) => {
          if (img.url.startsWith("blob:")) {
            URL.revokeObjectURL(img.url);
          }
        });
      },
      "image/png"
    );
  } catch (error) {
    console.error("Error in saveImage:", error);
    toast.error("Failed to save image. Please try again.");
  }
};

function cropCanvas(sourceCanvas) {
  const ctx = sourceCanvas.getContext("2d");
  const pixels = ctx.getImageData(0, 0, sourceCanvas.width, sourceCanvas.height);
  const { data, width, height } = pixels;

  let minX = width, minY = height, maxX = 0, maxY = 0;
  let found = false;

  for (let i = 0; i < data.length; i += 4) {
    if (data[i + 3] !== 0) { // pixel has some opacity
      const index = i / 4;
      const x = index % width;
      const y = Math.floor(index / width);

      found = true;
      if (x < minX) minX = x;
      if (y < minY) minY = y;
      if (x > maxX) maxX = x;
      if (y > maxY) maxY = y;
    }
  }

  if (!found) return sourceCanvas; // nothing to crop

  const cropWidth = maxX - minX + 1;
  const cropHeight = maxY - minY + 1;

  const cropped = document.createElement("canvas");
  cropped.width = cropWidth;
  cropped.height = cropHeight;

  const croppedCtx = cropped.getContext("2d");
  croppedCtx.drawImage(
    sourceCanvas,
    minX, minY, cropWidth, cropHeight,
    0, 0, cropWidth, cropHeight
  );

  return cropped;
}
  const bringToFront = (id) => {
    setImages((prevImages) => {
      const maxZIndex = Math.max(...prevImages.map((img) => img.zIndex));
      return prevImages.map((img) => ({
        ...img,
        zIndex: img.id === id ? maxZIndex + 1 : img.zIndex,
      }));
    });
  };

  async function getAllCategoryAndSubcategory() {
    let data = await getCategorySubcategory(props.userId);
    setCategories(data.data.data);
  }
  async function myWardrob() {
    let data = await coachWardrob();
    setMyWardrobeItems(data?.data?.data);
  }
  async function userWardrobe() {
    let data = await getUserById(props?.userId);
    let userData = data?.data?.data;
    setIsAccess(userData?.isAccess)
    setUserWardrobeItems(userData.wardrobes);
  }
  useEffect(() => {
    getAllCategoryAndSubcategory();
    myWardrob();
    userWardrobe();
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  useEffect(() => {
    if (initialImages.length > 0) {
      setImages(
        initialImages.map((url, idx) => ({
          id: Date.now().toString() + idx,
          url,
          x: 0,
          y: 0,
          width: 100,
          height: 100,
          rotation: 0,
          zIndex: idx,
        }))
      );
    }
  }, [initialImages]);

  // When initialImages is set, search for each in userWardrobeItems and add to selectedWardrobeItems
  useEffect(() => {
    if (initialImages.length > 0 && userWardrobeItems.length > 0&&isAccess) {
      const matched = userWardrobeItems.filter(item => initialImages.includes(item.image));
      setSelectedWardrobeItems(matched);
    }
  }, [initialImages, userWardrobeItems]);

  // Pinch-to-zoom and wheel zoom handlers
  useEffect(() => {
    const editor = editorRef.current;
    if (!editor) return;

    function getDistance(touches) {
      const [a, b] = touches;
      return Math.sqrt(
        Math.pow(a.clientX - b.clientX, 2) + Math.pow(a.clientY - b.clientY, 2)
      );
    }

    function handleTouchStart(e) {
      if (e.touches.length === 2) {
        lastTouchDistance.current = getDistance(e.touches);
      }
    }

    function handleTouchMove(e) {
  if (e.touches.length === 2 && lastTouchDistance.current && selectedImage) {
    const newDistance = getDistance(e.touches);
    const scaleChange = newDistance / lastTouchDistance.current;

    setImages((prevImages) =>
      prevImages.map((img) => {
        if (img.id === selectedImage.id) {
          let nextZoom = img.zoom * scaleChange;
          nextZoom = Math.max(0.5, Math.min(3, nextZoom));
          return { ...img, zoom: nextZoom };
        }
        return img;
      })
    );

    lastTouchDistance.current = newDistance;
    e.preventDefault();
  }
}

    function handleTouchEnd(e) {
      if (e.touches.length < 2) {
        lastTouchDistance.current = null;
      }
    }

    function handleWheel(e) {
  if ((e.ctrlKey || e.metaKey) && selectedImage) {
    e.preventDefault();
    setImages((prevImages) =>
      prevImages.map((img) => {
        if (img.id === selectedImage.id) {
          let nextZoom = img.zoom - e.deltaY * 0.01;
          nextZoom = Math.max(0.5, Math.min(3, nextZoom));
          return { ...img, zoom: nextZoom };
        }
        return img;
      })
    );
  }
}

    editor.addEventListener("touchstart", handleTouchStart, { passive: false });
    editor.addEventListener("touchmove", handleTouchMove, { passive: false });
    editor.addEventListener("touchend", handleTouchEnd);
    editor.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      editor.removeEventListener("touchstart", handleTouchStart);
      editor.removeEventListener("touchmove", handleTouchMove);
      editor.removeEventListener("touchend", handleTouchEnd);
      editor.removeEventListener("wheel", handleWheel);
    };
  }, []);

  const toggleWardrobeSelection = (itemId) => {
    setSelectedWardrobeIds((prev) =>
      prev.includes(itemId)
        ? prev.filter((id) => id !== itemId)
        : [...prev, itemId]
    );
  };
// console.log("selectedWardrobeIds",selectedWardrobeItems)
  // Function to create outfit from the selections in the User Wardrobe modal.
  const createOutfitData = () => {
    const userDetails = localStorage.getItem("userDetails");
    const user_id = JSON.parse(userDetails)._id;
    const outfitData = {
      outfits: combinedImageUrl, // you can use the combined image URL here
      coachId: user_id,
      user_id: props.userId,
      wardrobes: selectedWardrobeIds,
      categoryId: selectedCategory,
      subCategoryId: selectedsubCategory,
    };
    console.log("Outfit Data:", outfitData);
  };

  return (
    <div style={styles.container} >
      <div
        style={{ display: "flex", flexDirection: "column", marginTop: "40px" }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <div style={styles.inputContainer}>
            <input
              hidden
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, "", "file")}
              ref={fileInputRef}
              style={styles.fileInput}
            />
            {/* <button onClick={() => fileInputRef.current.click()} style={styles.button}>
                        Choose Image
                    </button>
                    <button onClick={() => setMyWardrobModel(true)} style={styles.button}>
                        My Wardrobe
                    </button> */}
            <button
              onClick={() => setUserWardrobModel(true)}
              style={styles.button}
            >
              User Wardrobe
            </button>
            <button
              onClick={() => props.setCreateOutfit(false)}
              style={{ ...styles.button, background: "#111", float: "right" }}
            >
              Close
            </button>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              gap: "30px",
              alignItems: "center",
            }}
          >
            <h1 style={styles.title}>Outfit Editor </h1>
            <div onClick={() => props.setCreateOutfit(false)}>
              <IoMdClose size={30} />
            </div>
          </div>
        </div>

        <div 
          style={{ display: "flex", display: userWardrobModel ? `none` : "" }}
        >
          <div
            ref={editorRef} style={{ ...styles.editor, touchAction: "none", overflow: "hidden" }}
          >
            {isAccess ? (
              <div 
              style={{
      position: "relative",
      width: "100%",
      height: "100%",
      // transform: `scale(${zoom})`,
      // transformOrigin: "center center",
    }}
                >
                {images.map((img) =>{ 
                  const isSelected = selectedImage && selectedImage.id === img.id;
                  const currentZoom = img.zoom || 1;

                  return(
                   <div
                key={img.id}
                onMouseDown={(e) => handleMouseDown(e, img.id)}
                onTouchStart={(e) => handleImageTouchStart(e, img.id)}
                onTouchMove={handleImageTouchMove}
                onTouchEnd={handleImageTouchEnd}
                style={{
                  ...styles.imageContainer,
                  left: `${img.x}px`,
                  top: `${img.y}px`,
                  width: `${img.width}px`,
                  height: `${img.height}px`,
                  transform: `scale(${currentZoom}) rotate(${img.rotation}deg)`,
                  // transformOrigin: "center center",
                  zIndex: img.zIndex,
                  border: selectedImage && selectedImage.id === img.id ? "2px solid #007bff" : "none",
                }}
              >
                <img src={img.url} alt="Wardrobe item" style={styles.image} />
              </div>
                )})}
              </div>
            ) : (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "white",
                }}
              >
                <p style={{ color: "red", fontSize: "15px" }}>
                  You do not have permission to access user wardrobe
                </p>
              </div>
            )}
          </div>
        </div>
        {userWardrobModel && (
          <>
            {isAccess ? (
              <div style={styles.modal}>
                <div style={styles.modalContent}>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h2>User Wardrobe</h2>
                    <div onClick={() => setUserWardrobModel(false)}>
                      <IoMdClose size={30} />
                    </div>
                  </div>

                  {/* Filter Section */}
                  <div
                    style={{
                      display: "flex",
                      width: "90%",
                      maxHeight: "500px",
                      overflowY: "auto",
                    }}
                  >
                    <div style={styles.filterContainer}>
                      <div>
                        <h4
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            marginBottom: "10px",
                          }}
                        >
                          {" "}
                          Category
                        </h4>
                        {categories.map((item) => (
                          <div
                            key={item._id}
                            onClick={() => {
                              setSelectedCategory(item._id);
                              setSubCategories(item.subcategories);
                            }}
                            className={
                              selectedCategory === item._id
                                ? "activeCategory"
                                : ""
                            }
                            style={{ padding: "0.5rem", cursor: "pointer" }}
                          >
                            {item.name}
                          </div>
                        ))}
                      </div>
                      <div>
                        <h4
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            marginBottom: "10px",
                          }}
                        >
                          Subcategory
                        </h4>
                        {subCategories.map((item) => (
                          <div
                            key={item._id}
                            onClick={() => setSelectedsubCategory(item._id)}
                            className={
                              selectedsubCategory === item._id
                                ? "activeCategory"
                                : ""
                            }
                            style={{ padding: "0.5rem", cursor: "pointer" }}
                          >
                            {item.name}
                          </div>
                        ))}
                      </div>
                    </div>
                    {/* Display filtered wardrobe items */}
                    <div style={styles.wardrobeItems}>
                      {userWardrobeItems
                        .filter((item) => {
                          // console.log("selectedCategory",userWardrobeItems,selectedCategory,selectedsubCategory)
                          if (selectedCategory && selectedsubCategory) {
                            return (
                              item.categoryId === selectedCategory &&
                              item.subcategoryId === selectedsubCategory
                            );
                          } else if (selectedCategory) {
                            return item.categoryId === selectedCategory;
                          }
                          return true;
                        })
                        .map((item) => {
                          return (
                            <div>
                              <img
                                key={item._id}
                                src={item.image}
                                alt="Wardrobe item"
                                style={styles.wardrobeItem}
                                onClick={() => {
                                  handleFileChange(
                                    item.image,
                                    item?._id,
                                    "url"
                                  );
                                  setUserWardrobModel(false);
                                  setSelectedWardrobeItems((prev) => [
                                    ...prev,
                                    item,
                                  ]);
                                  toggleWardrobeSelection(item._id);
                                }}
                              />
                            </div>
                          );
                        })}
                    </div>
                  </div>
                  {/* Button to create outfit object from selections */}
                  <button onClick={createOutfitData} style={styles.button}>
                    Create Outfit
                  </button>
                </div>
              </div>
            ) : (
              <div
                style={{
                  color: "red",
                  fontSize: "15px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "white",
                  width: "100%",
                  height: "10rem",
                  marginBottom: "2rem",
                }}
              >
                You do not have permission to access user wardrobe
              </div>
            )}
          </>
        )}
        <div style={styles.controlsContainer}>
          <button
            onClick={rotateImage}
          style={styles.controlButton}
          disabled={!selectedImage}
          >
            Rotate
          </button>
          <button
            onClick={() => resizeImage(1.1)}
            style={styles.controlButton}
            disabled={!selectedImage}
          >
            Increase Size
          </button>
          <button
            onClick={() => resizeImage(0.9)}
            style={styles.controlButton}
            disabled={!selectedImage}
          >
            Decrease Size
          </button>
          <button
            onClick={deleteImage}
            style={styles.controlButton}
            disabled={!selectedImage}
          >
            Delete
          </button>
        </div>
        <div style={styles.buttonContainer}>
          <button
          onClick={() => fileInputRef.current.click()}
          style={!isAccess ? styles.uploadButtonDisabled : styles.uploadButton}
          disabled={!isAccess}
        >
          Choose File
        </button>

        {/* Hidden file input */}
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          accept="image/*"
          onChange={(e)=>handleFileChange(e, "", "file")}
        />
             <button
          //   onClick={saveImage}
          onClick={() => {
            if (!isAccess) {
              toast.error("You do not have permission to access user wardrobe");
            }
            if (selectedWardrobeItems.length > 0) {
              setNamePopUp(true);
            }
          }}
          style={styles.saveButton}
        >
          Save and Upload
        </button>
        
        </div>
       
      </div>

      {/* My Wardrobe Modal */}
      {/* {myWardrobModel && (
                <div style={styles.modal}>
                    <div style={styles.modalContent}>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <h2>My Wardrobe</h2>
                            <div onClick={() => setMyWardrobModel(false)}>
                                <IoMdClose size={30} />
                            </div>
                        </div>
                        <div style={styles.wardrobeItems}>
                            {myWardrobeItems.map((item) => (
                                <img
                                    key={item._id}
                                    src={item.image}
                                    alt="Wardrobe item"
                                    style={styles.wardrobeItem}
                                    onClick={() => { handleFileChange(item.image, "", "url"); setMyWardrobModel(false); }}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )} */}

      {/* User Wardrobe Modal with Category/Subcategory Filters */}

      {namePopUp && (
        <div style={styles.modal}>
          <div
            style={{
              ...styles.modalContent,
              width: "500px", // Increased width
              height: "240px", // Increased height
              maxHeight: "90vh", // Optional for responsiveness
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h2>Outfit Name</h2>
              <div
                onClick={() => setNamePopUp(false)}
                style={{ cursor: "pointer" }}
              >
                <IoMdClose size={30} />
              </div>
            </div>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (!imageName.trim()) {
                  setNameError("Image name is required");
                  return;
                }
                setNameError("");
                saveImage();
                setNamePopUp(false);
              }}
            >
              <div style={{ margin: "1rem 0" }}>
                <label htmlFor="imageName">Name</label>
                <input
                  id="imageName"
                  type="text"
                  value={imageName}
                  placeholder="Enter Image name"
                  onChange={(e) => {
                    setImageName(e.target.value);
                    if (e.target.value.trim()) {
                      setNameError(""); // clear error as user types
                    }
                  }}
                  style={{
                    width: "100%",
                    padding: "0.5rem",
                    marginTop: "0.5rem",
                    borderBottom: "1px solid #ccc",
                    outline: "none",
                  }}
                  // required
                />
                {nameError && (
                  <p
                    style={{
                      color: "red",
                      marginTop: "0.15rem",
                      fontSize: "0.75rem",
                    }}
                  >
                    {nameError}
                  </p>
                )}
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "1rem",
                }}
              >
                <button type="submit" style={styles.button}>
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    width: "50%",
    margin: "0 auto",
    padding: "10px",
    zIndex: "1000",
  },
  title: {
    textAlign: "center",
    color: "#333",
    margin:"auto"
  },
  inputContainer: {
    display: "flex",
    gap: "10px",
  },
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  controlsContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginBottom: "10px",
  },
  controlButton: {
    padding: "10px 20px",
    fontSize: "14px",
    backgroundColor: "#28a745",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  editor: {
    position: "relative",
    backgroundColor: "white",
    width: "100%",
    height: "400px",
    marginBottom: "20px",
    overflow: "hidden",
    touchAction: "pan-x pan-y", // Allow panning but prevent pinch zoom on canvas
      userSelect: "none",
  },
  imageContainer: {
    position: "absolute",
    cursor: "move",
    touchAction: "none",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    pointerEvents: "none",
  },
  saveButton: {
    padding: "10px 20px",
    fontSize: "14px",
    backgroundColor: "#28a745",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    // display: "block",
    // margin: "0 auto",
  },
  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
      alignItems: "center",
    zIndex:9999
  },
  modalContent: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "5px",
    maxWidth: "90%",
    maxHeight: "80%",
    overflow: "auto",
  },
  wardrobeItems: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    width: "300px",
    marginTop: "1rem",
  },
  wardrobeItem: {
    width: "100px",
    height: "100px",
    objectFit: "cover",
    cursor: "pointer",
  },
  filterContainer: {
    border: "1px solid #ccc",
    padding: "10px",
    marginBottom: "1rem",
    display: "flex",
    gap: "10px",
  },
  buttonContainer:{
    width:"100%",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    gap:"1rem",

  },
  uploadButton : {
  padding: "8px 16px",
  fontSize: "14px",
  borderRadius: "4px",
  border: "1px solid #3182ce",
  backgroundColor: "#3182ce",
  color: "white",
  cursor: "pointer",
  transition: "all 0.2s ease",
},

uploadButtonDisabled : {
  opacity: 0.5,
   padding: "8px 16px",
  fontSize: "14px",
  borderRadius: "4px",
  border: "1px solid #3182ce",
  backgroundColor: "#3182ce",
  color: "white",
  cursor: "not-allowed",
}

};

export default OutfitEditor;
